import { TweenMax, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class SnowflakePolicyholderCost {
  // private _iconPolicyholder: TweenMax;
  // private _iconCost: TweenMax;
  // private _title1: TweenMax;
  // private _title2: TweenMax;
  // private _subtitle: TweenMax;
  // private _text01: TweenMax;
  // private _text02: TweenMax;
  // private _text03: TweenMax;
  // private _text04: TweenMax;
  // private _text05: TweenMax;
  // private _text06: TweenMax;
  // private _text07: TweenMax;
  // private _text08: TweenMax;
  // private _text09: TweenMax;
  // private _text10: TweenMax;
  // private _text11: TweenMax;
  // private _text12: TweenMax;
  // private _button1: TweenMax;
  // private _button2: TweenMax;
  // private _button3: TweenMax
  private _wrapper1: TweenMax;
  private _wrapper2: TweenMax;
  private _wrapper3: TweenMax;
  private _panel1: TweenMax;
  private _panel2: TweenMax;
  private _panel3: TweenMax;
  private _panelText1: TweenMax;
  private _panelText2: TweenMax;
  private _panelText3: TweenMax;
  private _panelText4: TweenMax;
  private _counter1: TweenMax;
  private _counter1Element: Element;
  private _counter1Value = { value: 0 }
  private _counter2: TweenMax;
  private _counter2Value = { value: 0 }
  private _counter2Element: Element;
  private _counter2SwapOut: TweenMax;
  private _counter2SwapIn: TweenMax;
  private _counter3: TweenMax;
  private _counter3Value = { value: 0 }
  private _counter3Element: Element;
  private _counter3SwapOut: TweenMax;
  private _counter3SwapIn: TweenMax;

  private _image1: TweenMax;
  private _image2: TweenMax;
  private _image3: TweenMax;

  // private _timelineTitle1 = new TimelineMax();
  // private _timelineTitle2 = new TimelineMax();
  private _timelineArticle1 = new TimelineMax();
  private _timelineArticle2 = new TimelineMax();
  private _timelineArticle3 = new TimelineMax();

  init ( ): void {
    this._counter1Element = document.getElementById('gsap-counter-1');
    this._counter2Element = document.getElementById('gsap-counter-2');
    this._counter3Element = document.getElementById('gsap-counter-3');

    // this._iconPolicyholder = TweenMax.fromTo('.policyholder-content .icon-policyholder path', { drawSVG: '0' }, { drawSVG: '100%', duration: 1, stagger: { from: 'random', amount: 0.5 } });
    // this._title1 = TweenMax.from('.policyholder-content header h2', { opacity:0, y: -30, duration: 1 })

    // this._text01 = TweenMax.from('.policyholder-content .gsap-article-1 h3', { opacity:0, y: -30, duration: 1 });
    // this._text02 = TweenMax.from('.policyholder-content .gsap-article-1 > p', { opacity:0, y: -30, duration: 1 });
    // this._text03 = TweenMax.from('.policyholder-content .gsap-article-1 aside h4', { opacity:0, y: -30, duration: 1 });
    // this._text04 = TweenMax.from('.policyholder-content .gsap-article-1 aside p', { opacity:0, y: -30, duration: 1 });
    this._wrapper1 = TweenMax.from('.policyholder-content .gsap-article-1 .image-wrapper', { opacity:0, duration: 1 });
    this._panel1 = TweenMax.from('.policyholder-content .gsap-article-1 blockquote', { opacity:0, y: 30, duration: 1 });
    this._panelText1 = TweenMax.from('.policyholder-content .gsap-panel-text-1', { opacity:0, y: -30, duration: 1 });
    // this._button1 = TweenMax.from('.policyholder-content .gsap-footer-1 p', { opacity:0, y: -30, duration: 1 });

    // this._text05 = TweenMax.from('.policyholder-content .gsap-article-2 h3', { opacity:0, y: -30, duration: 1 });
    // this._text06 = TweenMax.from('.policyholder-content .gsap-article-2 > p', { opacity:0, y: -30, duration: 1 });
    // this._text07 = TweenMax.from('.policyholder-content .gsap-article-2 aside h4', { opacity:0, y: -30, duration: 1 });
    // this._text08 = TweenMax.from('.policyholder-content .gsap-article-2 aside p', { opacity:0, y: -30, duration: 1 });
    this._wrapper2 = TweenMax.from('.policyholder-content .gsap-article-2 .image-wrapper', { opacity:0, duration: 1 });
    this._panel2 = TweenMax.from('.policyholder-content .gsap-article-2 blockquote', { opacity:0, y: 30, duration: 1 });
    this._panelText2 = TweenMax.from('.policyholder-content .gsap-panel-text-2', { opacity:0, y: -30, duration: 1 });
    this._panelText3 = TweenMax.from('.policyholder-content .gsap-panel-text-3', { opacity:0, y: -30, duration: 1 });
    // this._button2 = TweenMax.from('.policyholder-content .gsap-footer-2 p', { opacity:0, y: -30, duration: 1 });

    // this._iconCost = TweenMax.fromTo('.cost-content .icon-cost path, .cost-content .icon-cost line, .cost-content .icon-cost circle', { drawSVG: '0' }, { drawSVG: '100%', duration: 1, stagger: { from: 'random', amount: 0.5 } });
    // this._title2 = TweenMax.from('.cost-content header h2', { opacity:0, y: -30, duration: 1 })
    // this._subtitle = TweenMax.from('.cost-content header p', { opacity:0, y: -30, duration: 1 })

    // this._text09 = TweenMax.from('.cost-content article h3', { opacity:0, y: -30, duration: 1 });
    // this._text10 = TweenMax.from('.cost-content article > p', { opacity:0, y: -30, duration: 1 });
    // this._text11 = TweenMax.from('.cost-content article aside h4', { opacity:0, y: -30, duration: 1 });
    // this._text12 = TweenMax.from('.cost-content article aside p', { opacity:0, y: -30, duration: 1 });
    this._wrapper3 = TweenMax.from('.cost-content article .image-wrapper', { opacity:0, duration: 1 });
    this._panel3 = TweenMax.from('.cost-content article blockquote', { opacity:0, y: 30, duration: 1 });
    this._panelText4 = TweenMax.from('.cost-content .gsap-panel-text-4', { opacity:0, y: -30, duration: 1 });
    // this._button3 = TweenMax.from('.cost-content footer p', { opacity:0, y: -30, duration: 1 });

    this._image1 = TweenMax.from('.policyholder-content .gsap-article-1 .image', { scale:1.2, x: '10%', y: '10%', duration: 20 });
    this._image2 = TweenMax.from('.policyholder-content .gsap-article-2 .image', { scale:1.2, x: '10%', y: '10%', duration: 20 });
    this._image3 = TweenMax.from('.cost-content article .image', { scale:1.2, x: '10%', y: '10%', duration: 20 });

    this._counter1 = TweenMax.to( this._counter1Value, {
      value: 70,
      roundProps: 'value',
      duration: 2,
      onUpdate: () => {
        this._counter1Element.innerHTML = this._counter1Value.value.toString();
      }
    });

    this._counter2 = TweenMax.to( this._counter2Value, {
      value: 160300000,
      roundProps: 'value',
      duration: 2,
      onUpdate: () => {
        this._counter2Element.innerHTML = this._counter2Value.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    });
    this._counter2SwapOut = TweenMax.to( '.policyholder-content .gsap-article-2 .gsap-counter', { width: 0, opacity: 0, duration: 0.5 })
    this._counter2SwapIn = TweenMax.fromTo( '.policyholder-content .gsap-article-2 .gsap-counter-replace', { width: 0 }, { width: 180, duration: 0.5 })

    this._counter3 = TweenMax.to( this._counter3Value, {
      value: 750,
      roundProps: 'value',
      duration: 2,
      onUpdate: () => {
        this._counter3Element.innerHTML = this._counter3Value.value.toString();
      }
    });
    this._counter3SwapOut = TweenMax.to( '.cost-content article .gsap-counter', { width: 0, opacity: 0, duration: 0.5 })
    this._counter3SwapIn = TweenMax.fromTo( '.cost-content article .gsap-counter-replace', { width: 0 }, { width:180, duration: 0.5 })

    // this._timelineTitle1.add( this._iconPolicyholder );
    // this._timelineTitle1.add( this._title1, 1 );

    // this._timelineArticle1.add( this._text01 );
    // this._timelineArticle1.add( this._text02, 0.5 );
    // this._timelineArticle1.add( this._text03, 1 );
    // this._timelineArticle1.add( this._text04, 1.5 );
    this._timelineArticle1.add( this._wrapper1 );
    this._timelineArticle1.add( this._image1, 0 );
    this._timelineArticle1.add( this._panel1, 0.5 );
    this._timelineArticle1.add( this._counter1, 0.5 );
    this._timelineArticle1.add( this._panelText1, 2 );
    // this._timelineArticle1.add( this._button1, 3 );

    // this._timelineArticle2.add( this._text05 );
    // this._timelineArticle2.add( this._text06, 0.5 );
    // this._timelineArticle2.add( this._text07, 1 );
    // this._timelineArticle2.add( this._text08, 1.5 );
    this._timelineArticle2.add( this._wrapper2 );
    this._timelineArticle2.add( this._image2, 0 );
    this._timelineArticle2.add( this._panel2, 0.5 );
    this._timelineArticle2.add( this._counter2, 0.5 );
    this._timelineArticle2.add( this._counter2SwapOut, 2.5 );
    this._timelineArticle2.add( this._counter2SwapIn, 2.5 );
    this._timelineArticle2.add( this._panelText2, 2 );
    this._timelineArticle2.add( this._panelText3, 2.5 );
    // this._timelineArticle2.add( this._button2, 3 );

    // this._timelineTitle2.add( this._iconCost );
    // this._timelineTitle2.add( this._title2, 1 );
    // this._timelineTitle2.add( this._subtitle, 1.5 );

    // this._timelineArticle3.add( this._text09 );
    // this._timelineArticle3.add( this._text10, 0.5 );
    // this._timelineArticle3.add( this._text11, 1 );
    // this._timelineArticle3.add( this._text12, 1.5 );
    this._timelineArticle3.add( this._wrapper3 );
    this._timelineArticle3.add( this._image3, 0 );
    this._timelineArticle3.add( this._panel3, 0.5 );
    this._timelineArticle3.add( this._counter3, 0.5 );
    this._timelineArticle3.add( this._counter3SwapOut, 2.5 );
    this._timelineArticle3.add( this._counter3SwapIn, 2.5 );
    this._timelineArticle3.add( this._panelText4, 2 );
    // this._timelineArticle3.add( this._button3, 3 );

    // ScrollTrigger.create({
    //   animation: this._timelineTitle1,
    //   trigger: '.policyholder-content header',
    //   start: 'top center'
    // });

    ScrollTrigger.create({
      animation: this._timelineArticle1,
      trigger: '.policyholder-content .gsap-article-1',
      start: 'top center'
    });

    ScrollTrigger.create({
      animation: this._timelineArticle2,
      trigger: '.policyholder-content .gsap-article-2',
      start: 'top center'
    });

    // ScrollTrigger.create({
    //   animation: this._timelineTitle2,
    //   trigger: '.cost-content header',
    //   start: 'top center'
    // });

    ScrollTrigger.create({
      animation: this._timelineArticle3,
      trigger: '.cost-content article',
      start: 'top center'
    });
  }

  constructor ( ) { }
}
